import type { MouseEvent } from 'react';
import { Icon } from '../Icon';
import { IconButton } from '../IconButton';
import { useInBottomSheet } from './sheetContext';

type DialogCloseButtonProps = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

/**
 * The dialog's X (rendered by `Dialog` itself). Desktop only — the mobile bottom sheet closes by
 * swiping down or tapping outside, so it renders nothing there.
 */
export function DialogCloseButton({ onClick }: DialogCloseButtonProps) {
  const inSheet = useInBottomSheet();
  if (inSheet) return null;

  return (
    <IconButton variant="text" color="secondary" shape="circle" size="medium" aria-label="סגור" onClick={onClick}>
      <Icon icon="closeOutlined" color="inherit" />
    </IconButton>
  );
}
